import React, { useEffect } from "react";
import Loader from "./loader";
export const Splashscreen = () => {
    useEffect(() => {
        // console.log("loading splashscreen");
    }, []);
    return (React.createElement("div", { className: "splashscreen" },
        React.createElement(Loader, { text: "Loading..." })));
};
